import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["children", "sink"],
  _excluded2 = ["sink"];
var _class, _class2, _class3;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';

/**
 * Creates a sink and a renderer for a given component.
 */
export function makeSink(InnerComponent) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var sink = observable({
    count: 0,
    shouldRender: !!opts.alwaysRender,
    opts: opts,
    props: null
  }, {
    opts: observable.ref,
    props: observable.ref
  });
  var Sink = function Sink(props) {
    return /*#__PURE__*/React.createElement(ComponentSink, _extends({
      sink: sink
    }, props));
  };
  var Renderer = function Renderer(rendererProps) {
    return /*#__PURE__*/React.createElement(ComponentSinkRenderer, _extends({}, rendererProps, {
      sink: sink
    }), function (props) {
      return /*#__PURE__*/React.createElement(InnerComponent, props);
    });
  };
  return {
    Sink: Sink,
    Renderer: Renderer
  };
}

/**
 * Renders a single sink.
 */
export var ComponentSinkRenderer = observer(_class = /*#__PURE__*/function (_React$Component) {
  function ComponentSinkRenderer() {
    _classCallCheck(this, ComponentSinkRenderer);
    return _callSuper(this, ComponentSinkRenderer, arguments);
  }
  _inherits(ComponentSinkRenderer, _React$Component);
  return _createClass(ComponentSinkRenderer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        sink = _this$props.sink,
        props = _objectWithoutProperties(_this$props, _excluded);
      if (!sink.shouldRender) {
        return null;
      }
      return children(_objectSpread(_objectSpread({}, props), sink.props));
    }
  }]);
}(React.Component)) || _class;
ComponentSinkRenderer.propTypes = {
  children: PropTypes.func.isRequired,
  sink: PropTypes.any.isRequired
};

/**
 * Stuffs data into a sink so it'll be rendered.
 */
export var ComponentSink = observer(_class2 = (_class3 = /*#__PURE__*/function (_React$Component2) {
  function ComponentSink() {
    _classCallCheck(this, ComponentSink);
    return _callSuper(this, ComponentSink, arguments);
  }
  _inherits(ComponentSink, _React$Component2);
  return _createClass(ComponentSink, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSink(this.props, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeSink();
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps) {
      this.updateSink(nextProps);
    }
  }, {
    key: "updateSink",
    value: function updateSink(nextProps, newMount) {
      var sink = nextProps.sink,
        props = _objectWithoutProperties(nextProps, _excluded2);
      var prev = sink;
      Object.assign(sink, {
        props: props,
        shouldRender: true,
        count: newMount ? prev.count + 1 : prev.count
      });
    }
  }, {
    key: "removeSink",
    value: function removeSink() {
      var sink = this.props.sink;
      var prev = sink;
      var prevCount = prev.count - 1;
      if (prevCount === 0) {
        Object.assign(sink, {
          count: 0,
          shouldRender: !!sink.opts.alwaysRender
        });
      } else {
        Object.assign(sink, _objectSpread(_objectSpread({}, prev), {}, {
          shouldRender: true,
          count: prevCount
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
}(React.Component), _applyDecoratedDescriptor(_class3.prototype, "updateSink", [action], Object.getOwnPropertyDescriptor(_class3.prototype, "updateSink"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "removeSink", [action], Object.getOwnPropertyDescriptor(_class3.prototype, "removeSink"), _class3.prototype), _class3)) || _class2;
ComponentSink.propTypes = {
  sink: PropTypes.any.isRequired
};
//# sourceMappingURL=index.js.map
